var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary py-2 px-4",on:{"click":_vm.logout}},[_c('span',{staticClass:"oi oi-power-standby mr-2",staticStyle:{"font-size":"1rem"}}),_vm._v("\n    "+_vm._s(_vm.$t('common.logout'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ed20c5d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/ButtonLogout.vue
// module id = 151
// module chunks = 0